import React from "react";
import { ReactComponent as SettingsLogo } from "./CardIcons/settings.svg";
import {
  CardWrapper,
  LeftWrapper,
  RightWrapper,
  LogoWrapper,
  CenterWrapper,
} from "./Card.styled";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CircularIndeterminate from "../Loaders/CircularIndeterminate";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import Icon from "@material-ui/core/Icon";
import PersonIcon from "@material-ui/icons/Person";
import PropTypes from "prop-types";

const Card = ({
  isHidden = false,
  iconplusactive = false,
  activeicon = true,
  coloricon,
  code,
  title,
  icon,
  setFormTrigger,
  colorBorder,
  customStyle = {},
}) => {
  const renderSwitch = (icon) => {
    switch (icon) {
      case "add":
        return (
          <LogoWrapper>
            <AssignmentIcon style={{ fill: coloricon ? coloricon : "" }} />
          </LogoWrapper>
        );
      case "plus":
        return (
          <LogoWrapper>
            <Icon style={{ color: coloricon ? coloricon : "" }}>add</Icon>
          </LogoWrapper>
        );
      case "Person":
        return (
          <LogoWrapper colorBorder={colorBorder}>
            <PersonIcon />
          </LogoWrapper>
        );
      case "PersonAddIcon":
        return (
          <LogoWrapper colorBorder={colorBorder}>
            <PersonAddIcon />
          </LogoWrapper>
        );
      case "GroupAddIcon":
        return (
          <LogoWrapper colorBorder={colorBorder}>
            <GroupAddIcon />
          </LogoWrapper>
        );
      case "CircularIndeterminate":
        return (
          <LogoWrapper colorBorder={colorBorder} loader={true}>
            <CircularIndeterminate />
          </LogoWrapper>
        );
      default:
        return (
          <LogoWrapper>
            <SettingsLogo />
          </LogoWrapper>
        );
    }
  };

  return (
    <CardWrapper
      hidden={isHidden}
      onClick={() => setFormTrigger(code)}
      colorBorder={colorBorder}
      activeicon={activeicon}
      iconplusactive={iconplusactive}
      style={{ ...customStyle }}
    >
      <LeftWrapper hidden={activeicon === true ? false : true}>
        {renderSwitch(icon)}
      </LeftWrapper>
      {iconplusactive && (
        <CenterWrapper>
          <Icon style={{ color: coloricon ? coloricon : "" }}>add</Icon>
        </CenterWrapper>
      )}
      <RightWrapper iconplusactive={iconplusactive}>
        <h2 style={{ margin: "20px" }}>{title}</h2>
      </RightWrapper>
    </CardWrapper>
  );
};

export default Card;

Card.propTypes = {
  isHidden: PropTypes.bool,
  iconplusactive: PropTypes.bool,
  activeicon: PropTypes.bool,
  coloricon: PropTypes.string,
  code: PropTypes.any,
  title: PropTypes.string,
  icon: PropTypes.any,
  setFormTrigger: PropTypes.func,
  colorBorder: PropTypes.string,
  customStyle: PropTypes.object,
};
